export default "__VITE_ASSET__SWQVynz9__"